/**
 * Returns the base URL to use when building links that will be shared with
 * other people (e.g. SMS join links).
 *
 * In local development the host typically runs on `localhost:8080`, but
 * customers receiving the link are on a different device (phone) on the same
 * Wi-Fi network and can't reach `localhost`.  Vite injects the machine's LAN
 * address as `VITE_NETWORK_URL` at dev-time (see vite.config.ts) so we can
 * swap it in automatically.
 *
 * Priority:
 *   1. `VITE_PUBLIC_APP_URL` env-var (explicit override)
 *   2. `VITE_NETWORK_URL`   env-var (auto-detected LAN address, dev only)
 *   3. `window.location.origin` (fallback – works in production)
 *
 * Additionally applies the legacy meet.wlkthru.com → www.wlkthru.co rewrite.
 */
export function getShareableBaseUrl(): string {
  const explicit =
    (import.meta as any)?.env?.VITE_PUBLIC_APP_URL as string | undefined;

  if (explicit) {
    return explicit.replace("https://meet.wlkthru.com", "https://www.wlkthru.co");
  }

  // In dev, prefer the LAN URL so links work on other devices
  const networkUrl = import.meta.env.VITE_NETWORK_URL;

  if (networkUrl) {
    return networkUrl;
  }

  // Production fallback – origin already has the right host
  return window.location.origin.replace(
    "https://meet.wlkthru.com",
    "https://www.wlkthru.co"
  );
}
